import { createContext, PropsWithChildren } from 'react';
import LocalizationProvider from './LocalizationProvider';

export type ISettingsContext = {
    enableDOMAttributeRequired: boolean;
    loadingSubmitButton: boolean;
    hidingTabs: 'css' | 'js';
    labels: {
        range: string;
    };
    messages: {
        invalidValuesFromTo: string;
        invalidRangeOfValues: string;
        required: string;
    };
};

export const defaultContextValues: ISettingsContext = {
    enableDOMAttributeRequired: false,
    hidingTabs: 'css',
    loadingSubmitButton: false,
    labels: {
        range: 'Range'
    },
    messages: {
        invalidValuesFromTo: 'Value from or to is invalid',
        invalidRangeOfValues: 'Invalid range of values',
        required: 'Field is required.'
    }
};

const FormSettingsContext = createContext<Partial<ISettingsContext>>(defaultContextValues);

export const FormSettingsProvider = ({ children, value }: PropsWithChildren<{ value: Partial<ISettingsContext> }>) => {
    return (
        <LocalizationProvider>
            <FormSettingsContext.Provider value={{ ...defaultContextValues, ...value }}>
                {children}
            </FormSettingsContext.Provider>
        </LocalizationProvider>
    );
};
export default FormSettingsContext;
